import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@policystreet/localization";
import { catchError, throwError } from "rxjs";
import { AlertService } from "../services/alert.service";
import { SKIP_GLOBAL_ERROR_HANDLER } from "./http-context.tokens";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const alertService = inject(AlertService);
    const translate = inject(TranslateService);

    return next(req).pipe(
        catchError((error) => {
            console.error("Error:", error);

            // Opted-out requests handle their own failures. Rethrow the ORIGINAL error untouched:
            // this interceptor otherwise rethrows error.error (the body), which discards the status
            // code and headers a caller needs to distinguish rate limiting from an outage.
            if (req.context.get(SKIP_GLOBAL_ERROR_HANDLER)) {
                return throwError(() => error);
            }

            let errorMessage = translate.instant("ui.somethingWentWrong");

            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    errorMessage = translate.instant("ui.unauthorizedAccessPleaseLoginAgain");
                    router.navigateByUrl("service/invalid-token");
                } else if (error.status === 500) {
                    errorMessage = error.error?.message || translate.instant("ui.somethingWentWrong");
                } else {
                    const firstError = error.error?.errors?.[0]?.error;
                    errorMessage =
                        firstError ||
                        error.error?.message ||
                        error.error?.title ||
                        error.error ||
                        error.message ||
                        errorMessage;
                }

                alertService.openSnackBar(errorMessage);
                return throwError(() => error.error);
            }

            alertService.openSnackBar(error.message || errorMessage);
            return throwError(() => error.message);
        }),
    );
};
